import * as React from "react";
import { Route, Routes } from "react-router-dom";
import AppHeader from "./AppHeader";
import { useAuth } from "react-oidc-context";
import { GoACircularProgress } from "@abgov/react-components";
import PageTitle from "./PageTitle";
import { LoggedOut } from "./LoggedOut";
import OrdersList from "../pages/orders/OrdersList";
import OrderView from "../pages/orders/OrderView";
import OrderNew from "../pages/orders/OrderNew";
import { hasResourceRole } from "../utils/tokens";
import { permissions } from "../common/constants";
import Unauthorized from "./Unauthorized";
import AppFooter from "./AppFooter";

interface ILayoutProps { }
const appTitles = {
  'ordersList': 'Orders list | Resource Orders',
  'orderNew': 'Create new order | Resource Orders',
  'orderView' : 'View order | Resource Orders'
};

const Layout: React.FunctionComponent<ILayoutProps> = (props) => {
  const auth = useAuth();
  
const hasViewOrderPermission =
 hasResourceRole(
  String(process.env.REACT_APP_RESOURCEORDERS_CLIENT),
  permissions.ORDER_VIEW,
  auth.user?.access_token ?? ""
);

const hasTempReqViewOrderPermission =
 hasResourceRole(
  String(process.env.REACT_APP_RESOURCEORDERS_CLIENT),
  permissions.ORDER_TEMPREQUESTER_VIEW,
  auth.user?.access_token ?? ""
);

const hasWatcherViewOrderPermission =
 hasResourceRole(
  String(process.env.REACT_APP_RESOURCEORDERS_CLIENT),
  permissions.ORDER_WATCHER_VIEW,
  auth.user?.access_token ?? ""
);

const hasCreateOrderPermission = hasResourceRole(
  String(process.env.REACT_APP_RESOURCEORDERS_CLIENT),
  permissions.ORDER_CREATE,
  auth.user?.access_token ?? ""
);

const hasViewPermission = hasViewOrderPermission || hasTempReqViewOrderPermission || hasWatcherViewOrderPermission;

  return (
    <>
      <div className="wrapper">
        <AppHeader />
        <PageTitle titles={appTitles} />
        <div className={"row container"}>
          <div className="content col-12">
            {
             (!auth.isLoading &&  auth.user?.access_token) &&
            <Routes>
              <Route path="/home" element={hasViewPermission ? <OrdersList /> : <Unauthorized />} />
              <Route path="/" element={hasViewPermission ? <OrdersList /> : <Unauthorized />} />
              <Route path="*" element={hasViewPermission ? <OrdersList /> : <Unauthorized />} />
              <Route path='/logged-out' element={<LoggedOut />} />
              <Route path="/ordersList" element={hasViewPermission ? <OrdersList /> : <Unauthorized />} />
              <Route path="/order/id/:orderId" element={hasViewPermission ? <OrderView/>: <Unauthorized />} />
              <Route path="/order/orderNumber/:orderNumber" element={hasViewPermission ? <OrderView/>: <Unauthorized />} />
              {/* <Route path="/orderView/requester/:orderId" element={hasViewPermission ?  <OrderView isprocessor={false} /> : <Unauthorized />} />
              <Route path="/orderView/processor/:orderId" element={hasViewPermission ? <OrderView isprocessor={true} /> : <Unauthorized />} /> */}
              <Route path="/orderNew" element={hasCreateOrderPermission ? <OrderNew /> : <Unauthorized />} />
            </Routes>}
            {auth.isLoading && <GoACircularProgress visible={true} />} 
          </div>
        </div>
        <AppFooter />
      </div>
    </>
  );
};

export default Layout;
